


















import Vue from 'vue'
import { camelizeKeys, kebabToCamelCase } from '@/utils'

import ItemFactory from '../../elements/likert/ItemFactory'
import SurveyMixin from '../SurveyMixin'

const settings = kebabToCamelCase(require('./taq.yml'))
const factory = new ItemFactory(settings)

export default Vue.extend({
  mixins: [SurveyMixin],
  data() {
    return {
      settings,
    }
  },
})
